import * as Yup from 'yup';
import { Formik, Form } from "formik";
import SelectInput from '../inputs/SelectInput';
import { Button, Col, Row } from 'antd';
import { confirmationStatus, deliveryStatus, rolesConst } from '../../constants/others';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getData } from '../../helpers/api';
import { getLocalStorage } from '../../helpers/localstorage';
import DateInput from '../inputs/DateInput';
import { RxReset } from "react-icons/rx";
import { CiSearch } from "react-icons/ci";
import moment from 'moment';
import TextInput from '../inputs/TextInput';
import ExportExcel from '../ExportExcel';

const validationSchema = Yup.object({
    confimationStatus: Yup.string().nullable().optional(),
    deliveryStatus: Yup.string().nullable().optional(),
    userId: Yup.string().nullable().optional(),
    product: Yup.string().nullable().optional(),
    orderDate: Yup.date().nullable().optional(),
    phone: Yup.string().nullable().optional(),
    codeColis: Yup.string().nullable().optional(),
    duplicatePhone: Yup.bool().nullable().optional(),
})

const initialValue = {
    confimationStatus: null,
    deliveryStatus: null,
    userId: null,
    product: null,
    orderDate: '',
    phone: '',
    codeColis: '',
}
const FilterOrder = (props) => {
    const user = getLocalStorage("auth")?.user
    const { setFilter, filter } = props
    const [users, setUsers] = useState([])
    const [products, setProducts] = useState([])
    const [exportExcel, setExportExcel] = useState(false)
    const [deliveryMen, setDeliveryMen] = useState([])
    const confirmationStatusValues = useMemo(() => confirmationStatus.map((el) => ({ value: el, label: el })), [])
    const deliveryStatusValues = useMemo(() => deliveryStatus.map((el) => ({ value: el, label: el })), [])
    const getUsers = async () => {
        try {
            const res = await getData('/users/user/subordinated')
            setUsers(res.data.map((user) => ({ value: user.id, label: user.name })))
        } catch (error) {

        }
    }
    const getProducts = async () => {
        try {
            const res = await getData("/products");
            setProducts(res.data.map((product) => ({ value: product.id, label: product.name })))
        } catch (error) {
            console.log()
        }
    }


    const getDeliveryMen = useCallback(async () => {
        try {
            const res = await getData("/users/deliverymen");
            setDeliveryMen(res.data.map((deliveryMan) => ({ value: deliveryMan.id, label: deliveryMan.name })));
        } catch (error) {
            console.log("error fetching delivery men");
        }
    }, []);

    useEffect(() => {
        getUsers()
        getProducts()
        getDeliveryMen()
    }, [getDeliveryMen])

    return (
        <>
            {user?.role === rolesConst.SuperAdmin && <Button onClick={() => setExportExcel(true)} style={{ marginLeft: 'auto', marginBottom: 10 }} color="cyan">export excel</Button>}
            {exportExcel && <ExportExcel handleCancel={() => setExportExcel(false)} isModalOpen={exportExcel} products={products} users={users} />}
            <Formik
                initialValues={initialValue}
                validationSchema={validationSchema}
                onSubmit={(values, submitProps) => {
                    if (values.orderDate) {
                        values.orderDate = moment(values.orderDate).format('YYYY-MM-DD')
                    }
                    setFilter(values)
                }}
            >
                {({ resetForm, isValid, dirty }) => (
                    <Form
                    >
                        <Row
                            gutter={[5, 5]}
                        >
                            <Col xs={24} md={6} lg={4}>
                                <TextInput
                                    name="otherSearch"
                                    placeholder="Code colis,telephone, ville,prefix"
                                />
                            </Col>
                            <Col xs={24} md={6} lg={4}>
                                <DateInput
                                    name="orderDate"
                                    placeholder="Date de la commande"
                                />
                            </Col>
                            {user?.role !== "Livreur" && <Col xs={24} md={6} lg={4}>
                                <SelectInput
                                    name="confimationStatus"
                                    placeholder={"confimation"}
                                    options={confirmationStatusValues}
                                />
                            </Col>}
                            <Col xs={24} md={6} lg={4}>
                                <SelectInput
                                    name="deliveryStatus"
                                    placeholder={"Livraison"}
                                    options={deliveryStatusValues}
                                />
                            </Col>
                            <Col xs={24} md={6} lg={4}>
                                <SelectInput
                                    name="product"
                                    placeholder={"Produit"}
                                    options={products}
                                />
                            </Col>
                            <Col xs={24} md={6} lg={4}>
                                <SelectInput
                                    name="duplicatePhone"
                                    placeholder={"Téléphone double"}
                                    options={[{ value: true, label: "Téléphone double" }, { value: false, label: "Téléphone pas double" }]}
                                />
                            </Col>
                            {'super admin' === user?.role && <Col xs={24} md={6} lg={4}>
                                <SelectInput
                                    name="deliveryManId"
                                    placeholder="Livreurs"
                                    options={deliveryMen}
                                />
                            </Col>}
                            {['Gestion',
                                'Suivie',
                                'super admin'].includes(user?.role) && <Col xs={24} md={6} lg={4}>
                                    <SelectInput
                                        name="userId"

                                        placeholder={"Subordonnés"}
                                        options={users}
                                    />
                                </Col>}
                            <Col xs={24} md={6} lg={4}>
                                <Button style={{ marginRight: 5 }} disabled={!isValid || !dirty} size='default' type="primary" htmlType="submit">
                                    <CiSearch />
                                </Button>
                                <Button style={{ marginLeft: 5 }} disabled={!isValid || !dirty || !Object.keys(filter).length} size='default' color="default" onClick={() => {
                                    resetForm()
                                    setFilter({})
                                }}>
                                    <RxReset />
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        </>
    );
}

export default FilterOrder;